await import('/home/ubuntu/yanglao/platform-demo/node_modules/@umijs/bundler-webpack/client/client/client.js');
await import('/home/ubuntu/yanglao/platform-demo/src/.umi/umi.ts');
export default 1;